// 发起签约
import axiosRequest from '@/utils/request'

export const bind = (data) => {
  return axiosRequest({
    url: '/sign/bind',
    method: 'post',
    data
  })
}
